"use client";

import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const faqData = [{
  question: "What should I expect during my first chiropractic visit?",
  answer: "Your initial consultation involves a comprehensive health history and physical examination. Our practitioners will discuss your specific symptoms and wellness goals before creating a personalized treatment plan designed for your body's unique requirements."
}, {
  question: "Do you offer services in both Limassol and Nicosia?",
  answer: "Yes, Bodywerks operates in two convenient locations. We serve patients at our modern clinics in both Limassol and Nicosia, ensuring accessible professional care for both the local Cypriot and international expat communities."
}, {
  question: "Is chiropractic care safe during pregnancy?",
  answer: "Absolutely. We specialize in pregnancy chiropractic care, utilizing gentle, non-invasive techniques to help manage back pain and pelvic discomfort, supporting a more comfortable journey through every trimester for both mother and baby."
}, {
  question: "What is the difference between dry needling and acupuncture?",
  answer: "While both use thin needles, acupuncture is based on traditional medicine to balance energy flow (meridians) for holistic health, whereas dry needling targets specific muscular trigger points to relieve chronic tension and musculoskeletal pain."
}, {
  question: "Do I need a referral from a GP to book an appointment?",
  answer: "No referral is necessary to visit Bodywerks. You can book directly with us for any of our services, including chiropractic adjustments, massage therapy, or cosmetic treatments, at either of our Cyprus clinic locations."
}];
export default function FrequentlyAskedQuestions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="19155" id="frequently-asked-questions" ref={ref} className={cn("bg-[#F8F8F6] relative w-full py-24 overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-[#3B8FD4]/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#3B8FD4]/5 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-8 lg:col-start-3">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-5xl font-serif font-medium text-[#1A1A2E] mb-4 tracking-tight">
                Frequently Asked Questions
              </h2>
              <p className="text-[#4A5568] font-sans text-lg max-w-2xl mx-auto">
                Everything you need to know about our treatments, clinics, and care philosophy. Can’t
                find the answer you’re looking for? Please reach out to our professional team.
              </p>
            </div>

            <Accordion type="single" collapsible className="w-full space-y-4">
              {faqData.map((item, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-[#E2E8F0] px-2">
                  <AccordionTrigger className="text-[18px] font-sans font-semibold text-[#1A1A2E] hover:text-[#3B8FD4] hover:no-underline py-6 [&>svg]:text-[#3B8FD4] [&>svg]:stroke-2 transition-colors duration-300">
                    {item.question}
                  </AccordionTrigger>
                  <AccordionContent className="bg-white/60 rounded-xl mb-4 px-6 py-6 text-[16px] leading-[1.6] text-[#4A5568] font-sans backdrop-blur-sm border border-[#E2E8F0] shadow-sm">
                    {item.answer}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>

            <div className="mt-12 text-center">
              <p className="text-[#4A5568] font-sans mb-6">
                Still have questions about our specialized care? We're here to help.
              </p>
              <Button asChild variant="outline" className="rounded-full border-[#3B8FD4] text-[#3B8FD4] hover:bg-[#3B8FD4] hover:text-white transition-all duration-300 px-8 py-6 h-auto text-base font-sans">
                <Link to="/ContactPage">Contact Our Specialists</Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}